import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
interface ISelectPayTypeProps {
  priceType: string;
  currency: string;
}

// 이니시스 or 현금결제 선택
const SelectPayType = ({ priceType, currency }: ISelectPayTypeProps) => {
  const { register } = useFormContext();
  const { t } = useTranslation();
  const { lang } = useRouter();
  return (
    <>
      {/* premium일때만 표기되는 듯 */}
      <h4 className="form-title">
        {priceType && t("siteType.basic.detail.payment.title")}
      </h4>

      <div className="d-flex gap-4">
        <Form.Check
          type="radio"
          id="selectPayType_card"
          value="card"
          {...register("selectPayType")}
          label={
            <span className="form-input-label">
              {currency === "WON" ? (
                <i className="icon_inicis" />
              ) : (
                <i className="icon_paypal" />
              )}
            </span>
          }
        />

        {currency === "WON" && (
          <Form.Check
            type="radio"
            id="selectPayType_cash"
            value="cash"
            {...register("selectPayType")}
            label={
              <span
                className={`form-input-label ${lang === "ko" ? "" : "ml-24"}`}
              >
                {t("cashStatus.pay_cash")}
              </span>
            }
          />
        )}
      </div>
    </>
  );
};

export default SelectPayType;
